var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c(
        "csp-desktop-info-card",
        {
          ref: "infoCard",
          staticClass: "col-xl-12 col-12",
          attrs: {
            "form-context": _vm.repairSequencePlanFormContext,
            icon: "inticon-repair",
            title: "Reparaturablaufplan",
          },
          on: { save: _vm.saveRepairFormData },
        },
        [
          _vm._l(_vm.subformIdentifiers, function (subformIdentifier) {
            return _c(
              "b-row",
              { key: subformIdentifier },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "3" } },
                  [
                    _c("csp-desktop-info-card-element", {
                      attrs: {
                        "form-context": _vm.repairSequencePlanFormContext,
                        label: "Bezeichnung",
                        property: "type",
                        required: true,
                        "subform-identifier": subformIdentifier,
                        type: "autocomplete",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleTypeChange(subformIdentifier)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "3" } },
                  [
                    _vm.needsFurtherDescription(subformIdentifier)
                      ? _c("csp-desktop-info-card-element", {
                          attrs: {
                            "form-context": _vm.repairSequencePlanFormContext,
                            label: "Beschreibung",
                            property: "description",
                            required: true,
                            "subform-identifier": subformIdentifier,
                            type: "text",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "2" } },
                  [
                    _c("csp-desktop-info-card-element", {
                      attrs: {
                        "form-context": _vm.repairSequencePlanFormContext,
                        label: "Datum",
                        "max-date": null,
                        property: "startDate",
                        required: false,
                        "subform-identifier": subformIdentifier,
                        type: "datepicker",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "1" } },
                  [
                    _vm.isStartTimeEditable(subformIdentifier)
                      ? _c("csp-desktop-info-card-element", {
                          attrs: {
                            "form-context": _vm.repairSequencePlanFormContext,
                            label: "Uhrzeit",
                            property: "startTime",
                            required: false,
                            step: "60",
                            "subform-identifier": subformIdentifier,
                            type: "time",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "2" } },
                  [
                    _vm.isInEditMode
                      ? _c("csp-desktop-info-card-element", {
                          staticClass: "align-content-end",
                          attrs: {
                            "form-context": _vm.repairSequencePlanFormContext,
                            "hide-label": true,
                            label: "PDF Ausgabe",
                            property: "addToDocument",
                            required: false,
                            "subform-identifier": subformIdentifier,
                            type: "checkbox",
                          },
                        })
                      : !_vm.getAddToDocument(subformIdentifier)
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "info-card-element align-content-center",
                          },
                          [
                            _vm._v(
                              "\n                    Keine PDF Ausgabe\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.repairSequencePlanFormContext.isInEditMode
                  ? _c(
                      "b-col",
                      {
                        staticStyle: {
                          "padding-top": "16px",
                          height: "64px",
                          "padding-bottom": "15px",
                        },
                        attrs: { cols: "1" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-1",
                            attrs: { variant: "secondary" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteStep(subformIdentifier)
                              },
                            },
                          },
                          [_c("i", { staticClass: "inticon inticon-trash" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.addStep(
                                  _vm.repairSequencePlanFormContext.form.getDataOfSubform(
                                    subformIdentifier
                                  ).sortOrder
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "inticon inticon-add" })]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.repairSequencePlanFormContext,
                  label: "Reparaturdatum",
                  "max-date": null,
                  property: "repairAppointmentDate",
                  required: false,
                  type: "datepicker",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-9",
                attrs: {
                  "form-context": _vm.repairSequencePlanFormContext,
                  label: "Bemerkungen",
                  property: "remarksRepairSequencePlan",
                  required: false,
                  type: "autogrowtextarea",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.repairSequencePlanFormContext?.isInEditMode
            ? _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "6" } }),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "6" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.createPDF },
                        },
                        [
                          _vm._v(
                            "\n                    PDF erzeugen\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.sendNotification },
                        },
                        [
                          _vm._v(
                            "\n                    An Kanzlei / SD senden\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.repairSequencePlanFormContext.permissions
                        .canDocumentExternalAction
                        ? _c("external-service-provider-action", {
                            attrs: { "record-id": _vm.recordId },
                            on: {
                              saved: function ($event) {
                                return _vm.reloadSteps()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }